export default "__VITE_ASSET__DOs7qYbF__"